// https://developers.google.com/web/updates/2015/08/using-requestidlecallback
// https://github.com/Financial-Times/polyfill-library/blob/46f183701399f7f81ae409c7f5a536edf2817902/polyfills/requestIdleCallback/polyfill.js

if (!detect()) {
  invoke()
}

function detect() {
  return 'requestIdleCallback' in window
}

function invoke() {
  let idleCallbackIdentifier = 0
  let scheduledCallbacks = []
  let timedOutCallbacks = []
  let nestedCallbacks = []

  let isIdleScheduled = false
  let isCallbackRunning = false
  let allowIdleDeadlineConstructor = false

  let scheduledAnimationFrameId
  let scheduledAnimationFrameTimeout

  let previousFrameTime = 33
  let activeFrameTime = 33

  let frameDeadline = 0

  let port
  let messageKey
  const messageChannelSupport = typeof MessageChannel !== 'undefined'

  if (messageChannelSupport) {
    const messageChannel = new MessageChannel()
    port = messageChannel.port2
    messageChannel.port1.onmessage = processIdleCallbacks
  } else {
    messageKey = 'polyfillIdleCallback' + Math.random().toString(36).slice(2)
    port = window
    window.addEventListener('message', (event) => {
      if (event.source !== window || event.data !== messageKey) {
        return
      }
      processIdleCallbacks()
    })
  }

  function timeRemaining() {
    return Math.min(frameDeadline - performance.now(), 50)
  }

  function getDeadline(callbackObject) {
    const timeout = callbackObject.options.timeout
    const added = callbackObject.added
    allowIdleDeadlineConstructor = true

    const deadline = new window.IdleDeadline()
    allowIdleDeadlineConstructor = false

    Object.defineProperty(deadline, 'didTimeout', {
      value: timeout ? added + timeout < performance.now() : false
    })
    Object.defineProperty(deadline, 'timeRemaining', {
      value: timeRemaining
    })

    return deadline
  }

  function runCallback(callbackObject) {
    const deadline = getDeadline(callbackObject)
    const callback = callbackObject.callback
    callback(deadline)
  }

  function scheduleIdleWork() {
    if (!isIdleScheduled) {
      isIdleScheduled = true
      try {
        port.postMessage(messageKey, '*')
      } catch (_err) {
        port.postMessage(messageKey)
      }
    }
  }

  function scheduleAnimationFrame() {
    if (!scheduledAnimationFrameId) {
      scheduledAnimationFrameId = requestAnimationFrame((rafTime) => {
        scheduledAnimationFrameId = undefined
        clearTimeout(scheduledAnimationFrameTimeout)
        const futureRafTime = rafTime - activeFrameTime > performance.now()
        if (futureRafTime) {
          rafTime = rafTime - (activeFrameTime * 2)
        }

        let nextFrameTime = rafTime - frameDeadline + activeFrameTime
        if (nextFrameTime < activeFrameTime && previousFrameTime < activeFrameTime) {
          if (nextFrameTime < 8) {
            nextFrameTime = 8
          }

          activeFrameTime = Math.max(previousFrameTime, nextFrameTime)
        } else {
          previousFrameTime = nextFrameTime
        }

        frameDeadline = rafTime + activeFrameTime
        scheduleIdleWork()
      })

      scheduledAnimationFrameTimeout = setTimeout(() => {
        cancelAnimationFrame(scheduledAnimationFrameId)
        scheduledAnimationFrameId = undefined
        frameDeadline = performance.now() + 50
        scheduleIdleWork()
      }, 100)
    }
  }

  function processIdleCallbacks() {
    isIdleScheduled = false
    isCallbackRunning = true

    timedOutCallbacks = scheduledCallbacks.filter((callbackObject) => {
      if (callbackObject.options.timeout !== undefined) {
        const deadline = getDeadline(callbackObject)
        return deadline.didTimeout
      }
      return false
    })

    scheduledCallbacks = scheduledCallbacks.filter((callbackObject) => {
      return !timedOutCallbacks.includes(callbackObject)
    })

    timedOutCallbacks.sort((a, b) => {
      return a.options.timeout - b.options.timeout
    })

    while (timedOutCallbacks.length > 0) {
      const callbackObject = timedOutCallbacks.shift()
      runCallback(callbackObject)
    }

    while (scheduledCallbacks.length > 0 && timeRemaining() > 0) {
      const callbackObject = scheduledCallbacks.shift()
      runCallback(callbackObject)
    }

    if (nestedCallbacks.length > 0) {
      scheduledCallbacks = scheduledCallbacks.concat(nestedCallbacks)
      nestedCallbacks = []
    }

    if (scheduledCallbacks.length > 0) {
      scheduleAnimationFrame()
    }

    isCallbackRunning = false
  }

  window.requestIdleCallback = function requestIdleCallback(callback, options) {
    const id = ++idleCallbackIdentifier
    const callbackObject = {
      id,
      callback,
      options: options || {},
      added: performance.now()
    }

    if (isCallbackRunning) {
      nestedCallbacks.push(callbackObject)
    } else {
      scheduledCallbacks.push(callbackObject)
    }

    scheduleAnimationFrame()

    return id
  }

  window.cancelIdleCallback = function cancelIdleCallback(id) {
    if (arguments.length === 0) {
      throw new TypeError('cancelIdleCallback requires at least 1 argument')
    }

    const callbackFilter = function(callbackObject) {
      return callbackObject.id !== id
    }

    scheduledCallbacks = scheduledCallbacks.filter(callbackFilter)
    nestedCallbacks = nestedCallbacks.filter(callbackFilter)
  }

  window.IdleDeadline = function IdleDeadline() {
    if (!allowIdleDeadlineConstructor) {
      throw new TypeError('Illegal constructor')
    }
  }

  Object.defineProperty(window.IdleDeadline.prototype, 'timeRemaining', {
    value() {
      throw new TypeError('Illegal invocation')
    }
  })

  if (Object.prototype.hasOwnProperty('__defineGetter__')) {
    Object.defineProperty(window.IdleDeadline.prototype, 'didTimeout', {
      get() {
        throw new TypeError('Illegal invocation')
      }
    })
  } else {
    Object.defineProperty(window.IdleDeadline.prototype, 'didTimeout', {
      value: undefined
    })
  }
}
